import { render, staticRenderFns } from "./co-urging-case.vue?vue&type=template&id=937c921a&scoped=true"
import script from "./co-urging-case.vue?vue&type=script&lang=ts"
export * from "./co-urging-case.vue?vue&type=script&lang=ts"
import style0 from "./co-urging-case.vue?vue&type=style&index=0&id=937c921a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937c921a",
  null
  
)

export default component.exports